import script from "./ScrollProgressComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollProgressComponent.vue?vue&type=script&setup=true&lang=js"

import "./ScrollProgressComponent.vue?vue&type=style&index=0&id=7d5628ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d5628ba"]])

export default __exports__